'use client'

import Link from 'next/link'
import React, { useActionState } from 'react'

import { passwordDimenticata, reimpostaPassword, type StatoForm } from '../actions'
import { PASSWORD_MIN } from '../regole'
import { ErroreCampo, Esito } from './Feedback'

const iniziale: StatoForm = { stato: 'idle' }

export const FormPasswordDimenticata: React.FC = () => {
  const [stato, azione, inCorso] = useActionState(passwordDimenticata, iniziale)

  if (stato.stato === 'ok') {
    return (
      <div className="accountform">
        <Esito stato={stato} />
        <Link className="textlink" href="/account">
          ← Torna all’accesso
        </Link>
      </div>
    )
  }

  return (
    <form action={azione} className="accountform" aria-label="Password dimenticata">
      <label>
        Email
        <input
          autoComplete="email"
          defaultValue={stato.valori?.email}
          name="email"
          required
          type="email"
        />
        <ErroreCampo messaggio={stato.campi?.email} />
      </label>
      <button className="primary" disabled={inCorso} type="submit">
        {inCorso ? 'Invio in corso…' : 'Inviami il link →'}
      </button>
      <Esito stato={stato} />
    </form>
  )
}

export const FormReimpostaPassword: React.FC<{ token: string }> = ({ token }) => {
  const [stato, azione, inCorso] = useActionState(reimpostaPassword, iniziale)

  return (
    <form action={azione} className="accountform" aria-label="Reimposta la password">
      <input name="token" type="hidden" value={token} />
      <label>
        Nuova password
        <input
          autoComplete="new-password"
          minLength={PASSWORD_MIN}
          name="password"
          required
          type="password"
        />
        <ErroreCampo messaggio={stato.campi?.password} />
      </label>
      <label>
        Ripeti la password
        <input
          autoComplete="new-password"
          minLength={PASSWORD_MIN}
          name="conferma"
          required
          type="password"
        />
        <ErroreCampo messaggio={stato.campi?.conferma} />
      </label>
      <small>Usa almeno {PASSWORD_MIN} caratteri.</small>
      <button className="primary" disabled={inCorso} type="submit">
        {inCorso ? 'Salvataggio…' : 'Salva la nuova password →'}
      </button>
      <Esito stato={stato} />
      {stato.stato === 'errore' && stato.messaggio && (
        <Link className="textlink" href="/account/password-dimenticata">
          Richiedi un nuovo link →
        </Link>
      )}
    </form>
  )
}
